<template>
  <SwitchPage />
</template>

<script>
import SwitchPage from './switch.vue'

export default {
  name: 'ThirdPartyConfig',
  components: {
    SwitchPage
  }
}
</script>
